<template>
  <VContainer class="flex flex-col gap-4">
    <EmptyConsultations v-if="consultationCount === 0" />

    <template v-else>
      <DirectConsultationCard
        v-for="item in sortedDirectConsultation"
        :key="item.id"
        :consultation="item"
        :show-action-buttons="showActionButtons"
        :show-edit-button="showEditButton"
        @updateAssignedDoctor="item.assignedTo = $event"
      />
      <ScheduledConsultationCard
        v-for="item in sortedScheduledConsultations"
        :key="item.id"
        :consultation="item"
        :show-action-buttons="showActionButtons"
        :show-edit-button="showEditButton"
        :current-tab="currentTab"
      />
    </template>
  </VContainer>
</template>

<script setup lang="ts">
import DirectConsultationCard from '@/components/consultationrequest/DirectConsultationCard.vue'
import ScheduledConsultationCard from '@/components/consultationrequest/ScheduledConsultationCard.vue'
import {
  compareConsultationRequests,
  compareScheduledConsultationRequests
} from '@/util/compareConsultationRequests'
import { computed } from 'vue'
import EmptyConsultations from './EmptyConsultations.vue'
import { type ConsultationRequestDTO, type ScheduledConsultationDTO } from '@/generated'
import type { ConsultationsViewTab } from '@/util/consultationsTab'

const {
  directConsultations = [],
  scheduledConsultations = [],
  showActionButtons = true,
  showEditButton = true,
  currentTab
} = defineProps<{
  directConsultations?: ConsultationRequestDTO[]
  scheduledConsultations?: ScheduledConsultationDTO[]
  showActionButtons?: boolean
  showEditButton?: boolean
  currentTab?: ConsultationsViewTab
}>()

const consultationCount = computed(() => {
  return directConsultations.length + scheduledConsultations.length
})

const sortedDirectConsultation = computed<ConsultationRequestDTO[]>(() =>
  [...directConsultations].sort(compareConsultationRequests)
)

const sortedScheduledConsultations = computed<ScheduledConsultationDTO[]>(() =>
  [...scheduledConsultations].sort(compareScheduledConsultationRequests)
)
</script>
